var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRemote = function SvgRemote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.422 28.135c.377.402 1.007.414 1.468.11a5.826 5.826 0 013.22-.965c1.19 0 2.298.355 3.221.965.461.304 1.09.293 1.469-.11.377-.403.36-1.042-.087-1.366a7.817 7.817 0 00-4.602-1.49c-1.72 0-3.31.553-4.603 1.49-.448.324-.464.963-.087 1.366zm11.45-3.67c.436.34 1.067.324 1.444-.079.378-.402.36-1.038-.07-1.384a12.938 12.938 0 00-8.135-2.862c-3.08 0-5.91 1.071-8.136 2.861-.43.346-.448.983-.07 1.385.378.403 1.008.42 1.443.08a10.946 10.946 0 016.763-2.326c2.55 0 4.897.868 6.762 2.325zm3.527-3.76c.425.353 1.056.336 1.434-.067.378-.403.36-1.038-.063-1.393A18.06 18.06 0 0060.11 15a18.06 18.06 0 00-11.659 4.245c-.422.355-.44.99-.063 1.393.378.403 1.009.42 1.434.068A16.067 16.067 0 0160.11 17c3.91 0 7.496 1.391 10.289 3.706z",
    fill: "#332C4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88.375V60c0-13.807-11.193-25-25-25S35 46.193 35 60v28.375A9.625 9.625 0 0044.625 98h30.75A9.625 9.625 0 0085 88.375z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16z",
    fill: "#DFDFE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v0c0-8.837-7.163-16-16-16v0c-8.837 0-16 7.163-16 16v0m32 0v0c0 8.837-7.163 16-16 16v0c-8.837 0-16-7.163-16-16v0m32 0H44",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 60c0-8.837-7.163-16-16-16s-16 7.163-16 16h32z",
    fill: "#FFD400"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v0c0-8.837-7.163-16-16-16v0c-8.837 0-16 7.163-16 16v0m32 0v0c0 8.837-7.163 16-16 16v0c-8.837 0-16-7.163-16-16v0m32 0H44",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 52,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#332C4A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 65,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#332C4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 65,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#332C4A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 52,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#332C4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 65,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#332C4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 84,
    width: 16,
    height: 6,
    rx: 3,
    fill: "#FFF9DC",
    stroke: "#332C4A",
    strokeWidth: 2
  })));
};

export default SvgRemote;